<script setup lang="ts">
import { watch } from 'vue';
import { useRouterTab } from '../router/useRouterTab';
import { useIframeKeepAlive } from './useIframeKeepAlive';
import IframeKeepAliveItem from './IframeKeepAliveItem.vue';

const { tabs } = useRouterTab();
const { renderableEntries, isActive, syncWithTabs } = useIframeKeepAlive();

watch(tabs, (list) => syncWithTabs(list.map((tab) => tab.fullPath)), {
  deep: true,
  immediate: true,
});
</script>

<template>
  <div class="itp-keepalive-host">
    <IframeKeepAliveItem
      v-for="entry in renderableEntries"
      :key="entry.key"
      :entry="entry"
      :visible="isActive(entry.key)"
    />
  </div>
</template>
